<div class="btn-group g-3">
  <button
    type="button"
    class="btn btn-success text-nowrap"
    (click)="onSaveToDevice()"
    [disabled]="(disabled$ | async) === true"
    ngbTooltip="Save the current changes to the device's configuration file. (ctrl+⇧+s)"
    placement="auto"
    container="body"
    [openDelay]="450"
  >
    <i class="bi-floppy-fill"></i>
    <span class="d-none d-xxxl-inline text-nowrap ms-2">SAVE CHANGES</span>
  </button>
  <button
    type="button"
    class="btn btn-secondary"
    ngbTooltip="Open the dialog to view and compare changes before saving the configuration file to the device."
    placement="auto"
    container="body"
    [openDelay]="450"
    (click)="onViewChangedValues()"
  >
    <i class="bi-arrow-left-right"></i>
  </button>
</div>
